import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCommunityAssignmentsProps = {
  id: number;
  search?: string;
};

export const keyCommunityAssignments: BaseKeyFunction<
  KeyCommunityAssignmentsProps
> = ({ id, search }) => ["community-assignments", id.toString(), search ?? ""];
